const queryString = require("query-string");
let manifest = require("../../../sdk/content-manifest.json");
import * as _ from "lodash";
import { LIB_PREFIX } from "../TypesAndIdentifiers";
export namespace URLHelper {
  export let urlParamsFromConfig: any;
  export function getUrlParams(): any {
    let urlParams = queryString.parse(decodeURIComponent(location.search));
    if (urlParams.params) {
      urlParams.params = JSON.parse(
        Buffer.from(urlParams.params, "base64").toString()
      );
    }
    return _.assign(
      {},
      URLHelper.urlParamsFromConfig,
      manifest.urlConfig.commonDefaults,
      urlParams
    );
  }

  export function initUrlParamsWithContentType(contentType): any {
    let path = contentType
      .split(LIB_PREFIX)[1]
      .split(".")
      .splice(1);
    URLHelper.urlParamsFromConfig = manifest[LIB_PREFIX][path[0]][path[1]].contentConfig;
  }
}
export default URLHelper;
